import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
  const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'development';
  const RELEASE = process.env.REACT_APP_VERSION || '1.0.0';

  if (!SENTRY_DSN) {
    console.warn('Sentry DSN not found. Error tracking is disabled.');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    release: `klass-frontend@${RELEASE}`,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
      Sentry.captureConsoleIntegration({
        levels: ['error', 'warn'],
      }),
    ],

    tracesSampleRate: ENVIRONMENT === 'production' ? 0.1 : 1.0,

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    beforeSend(event, hint) {
      if (ENVIRONMENT === 'development') {
        console.log('Sentry Event:', event);
        console.log('Sentry Hint:', hint);
      }

      if (event.exception) {
        const error = hint.originalException;

        if (error?.isAxiosError) {
          event.contexts = {
            ...event.contexts,
            axios: {
              url: error.config?.url,
              method: error.config?.method,
              status: error.response?.status,
              statusText: error.response?.statusText,
              data: error.response?.data,
            },
          };
        }
      }

      return event;
    },

    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      /Loading chunk [\d]+ failed/,
      'Network request failed',
      'Failed to fetch',
    ],

    denyUrls: [/extensions\//i, /^chrome:\/\//i, /^chrome-extension:\/\//i],
  });

  Sentry.setTag('app', 'klass-frontend');
  Sentry.setTag('platform', 'web');

  console.log(`✅ Sentry initialized for ${ENVIRONMENT} environment`);
};

export const captureException = (error, context = {}) => {
  Sentry.captureException(error, {
    extra: context,
  });
};

export const captureMessage = (message, level = 'info', context = {}) => {
  Sentry.captureMessage(message, {
    level,
    extra: context,
  });
};

export const setUser = user => {
  if (user) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      username: user.name || user.username,
      role: user.role,
    });
  } else {
    Sentry.setUser(null);
  }
};

export const addBreadcrumb = (message, category = 'custom', level = 'info', data = {}) => {
  Sentry.addBreadcrumb({
    message,
    category,
    level,
    data,
  });
};

export default Sentry;
